import MuiTab from '@mui/material/Tab';
import MuiTabs from '@mui/material/Tabs';
import { PageLayout } from '@src/common/components/Page';
import { ExchangeRateManager } from '@src/exchangeRateManager/ExchangeRateManager';
import { TabPanel } from '@src/orders/TabPanel';
import { PermitTypesManager } from '@src/permitTypesManager/PermitTypesManager';
import { QuickbooksSettings } from '@src/quickbooks/QuickbooksSettings';
import { SettingsNavigation } from '@src/routing/SettingsNavigation';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';

export const SettingsPage = () => {
  const { t } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();
  const [currentTab, setCurrentTab] = useState(
    searchParams.get(SettingsNavigation.searchParamKey)
      ? parseInt(searchParams.get(SettingsNavigation.searchParamKey)!)
      : 0,
  );

  const handleTabChange = (index: number) => {
    setCurrentTab(index);
    searchParams.set(SettingsNavigation.searchParamKey, index.toString());
    setSearchParams(searchParams);
  };
  const tabProps = (tabNumber: number) => {
    return {
      id: `horizontal-tab-${tabNumber}`,
      'aria-controls': `horizontal-tabpanel-${tabNumber}`,
    };
  };

  return (
    <PageLayout title={t('settings.title')}>
      <>
        <MuiTabs
          TabIndicatorProps={{ style: { height: '1px' } }}
          sx={{ marginBottom: 4 }}
          value={currentTab}
          onChange={(_, index) => handleTabChange(index)}
        >
          <MuiTab label={t('permitTypesManager.action')} {...tabProps(0)} />
          <MuiTab label={t('exchangeRate.title')} {...tabProps(1)} />
          <MuiTab label={t('integrations.title')} {...tabProps(2)} />
        </MuiTabs>
        <TabPanel index={0} value={currentTab}>
          <PermitTypesManager />
        </TabPanel>
        <TabPanel index={1} value={currentTab}>
          <ExchangeRateManager />
        </TabPanel>
        <TabPanel index={2} value={currentTab}>
          <QuickbooksSettings />
        </TabPanel>
      </>
    </PageLayout>
  );
};
